// This is a pattern to organize all possible actions regarding this store
// Notice that every enum declared here is a reducer and need to be declared like an action

// Declaration of all the constants used through the app to manage incentive store data
enum IncentiveConstants {
  SetInitialData = 'SET_INITIAL_DATA',
  SetModelCardData = 'SET_MODEL_CARD_DATA',
  SetModelYears = 'SET_MODEL_YEARS',
  SetVehicleData = 'SET_VEHICLE_DATA',
  UpdateStoreByFormInput = 'UPDATE_STORE_BY_FORM_INPUT',
  ValidateForm = 'VALIDATE_FORM',
}

export default IncentiveConstants;
